import { ref } from 'vue'

/**
 * Shared "behave like a native app" state for the phone shell and the installed PWA.
 *
 * Lives outside Vue so the router (created at module load, before any component) can read it.
 * `useNativeAppMode()` in `App.vue` is the only writer.
 */
export const nativeAppMode = ref(false)

export function isStandaloneDisplay() {
  if (typeof window === 'undefined')
    return false

  return (
    window.matchMedia?.('(display-mode: standalone)').matches
    // iOS Safari exposes standalone via a non-standard navigator flag.
    || (navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}

export function isElectronShell() {
  if (typeof window === 'undefined')
    return false

  return Boolean(window.alkokhDesktop?.isElectron || navigator.userAgent.includes('Electron'))
}

/**
 * iPhone / iPad — the platforms whose edge-swipe walks browser history. iPadOS reports itself as
 * desktop Safari ("MacIntel"), so touch support is what tells it apart from a Mac.
 */
export function isAppleTouchDevice() {
  if (typeof navigator === 'undefined')
    return false

  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}
